import { Accordion, styled } from "@mui/material";

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  "&:last-of-type": {
    borderBottomLeftRadius: theme.radius.medium,
    borderBottomRightRadius: theme.radius.medium,
  },
  "&:first-of-type": {
    borderTopLeftRadius: theme.radius.medium,
    borderTopRightRadius: theme.radius.medium,
  },
}));

export default StyledAccordion;
